export default __webpack_public_path__ + "static/media/Team-Generator.c8eecbd3.JPG";